'use client';
import React, { useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Link from 'next/link';

const mockApplications = [
  { id: 'APP-12345678', type: 'تأشيرة دخول', status: 'قيد المراجعة', date: '2026/01/15', statusColor: 'bg-yellow-100 text-yellow-800' },
  { id: 'APP-87654321', type: 'موافقة أمنية', status: 'موافق عليه', date: '2026/01/10', statusColor: 'bg-green-100 text-green-800' },
  { id: 'APP-11223344', type: 'تجديد جواز', status: 'مكتمل', date: '2025/12/20', statusColor: 'bg-blue-100 text-blue-800' },
  { id: 'APP-55667788', type: 'تصديق وثيقة', status: 'معلق — نواقص', date: '2026/01/18', statusColor: 'bg-red-100 text-red-800' },
];

const stats = [
  { label: 'إجمالي الطلبات', value: '4', icon: '📎', color: 'bg-blue-50 text-blue-700' },
  { label: 'قيد المعالجة', value: '2', icon: '⏳', color: 'bg-yellow-50 text-yellow-700' },
  { label: 'مكتملة', value: '1', icon: '✅', color: 'bg-green-50 text-green-700' },
  { label: 'تحتاج مراجعة', value: '1', icon: '⚠️', color: 'bg-red-50 text-red-700' },
];

const tabs = ['لوحة التحكم', 'طلباتي', 'المدفوعات', 'سجل التدقيق', 'الإعدادات'];

export default function DashboardPage() {
  const [activeTab, setActiveTab] = useState('لوحة التحكم');

  return (
    <div className="min-h-screen flex flex-col font-tajawal" dir="rtl">
      <Navbar />
      <main className="flex-1 bg-background">
        {/* Header */}
        <div className="bg-gradient-to-br from-primary to-accent py-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-white">مرحباً، محمد علي</h1>
                <p className="text-white/70 text-sm mt-1">لوحة التحكم — منصة تصريح</p>
              </div>
              <Link href="/apply">
                <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-primary font-semibold rounded-xl hover:bg-white/90 transition-all shadow-lg text-sm">
                  + طلب جديد
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {stats?.map((stat) => (
              <div key={stat?.label} className={`rounded-xl border border-border p-5 ${stat?.color} flex items-center gap-4`}>
                <span className="text-3xl">{stat?.icon}</span>
                <div>
                  <div className="text-2xl font-bold">{stat?.value}</div>
                  <div className="text-xs opacity-80">{stat?.label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide mb-6 bg-white rounded-xl border border-border p-1">
            {tabs?.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`shrink-0 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  activeTab === tab
                    ? 'bg-primary text-white' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Applications Table */}
          {activeTab === 'لوحة التحكم' || activeTab === 'طلباتي' ? (
            <div className="bg-white rounded-2xl border border-border shadow-card overflow-hidden">
              <div className="p-5 border-b border-border flex items-center justify-between">
                <h2 className="font-bold text-foreground">طلباتي</h2>
                <Link href="/apply">
                  <button className="text-xs text-accent hover:underline font-medium">تقديم طلب جديد</button>
                </Link>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-muted">
                    <tr>
                      <th className="px-5 py-3 text-right text-xs font-semibold text-muted-foreground">رقم الطلب</th>
                      <th className="px-5 py-3 text-right text-xs font-semibold text-muted-foreground">نوع الخدمة</th>
                      <th className="px-5 py-3 text-right text-xs font-semibold text-muted-foreground">الحالة</th>
                      <th className="px-5 py-3 text-right text-xs font-semibold text-muted-foreground">تاريخ التقديم</th>
                      <th className="px-5 py-3 text-right text-xs font-semibold text-muted-foreground">إجراءات</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {mockApplications?.map((app) => (
                      <tr key={app?.id} className="hover:bg-muted/50 transition-colors">
                        <td className="px-5 py-4 text-sm font-mono text-foreground" dir="ltr">{app?.id}</td>
                        <td className="px-5 py-4 text-sm text-foreground">{app?.type}</td>
                        <td className="px-5 py-4">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${app?.statusColor}`}>
                            {app?.status}
                          </span>
                        </td>
                        <td className="px-5 py-4 text-sm text-muted-foreground" dir="ltr">{app?.date}</td>
                        <td className="px-5 py-4">
                          <div className="flex items-center gap-2">
                            <Link href={`/track?id=${app?.id}`}>
                              <button className="text-xs text-accent hover:underline">متابعة</button>
                            </Link>
                            <button className="text-xs text-muted-foreground hover:text-foreground">طباعة</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : activeTab === 'سجل التدقيق' ? (
            <div className="bg-white rounded-2xl border border-border shadow-card p-6">
              <h2 className="font-bold text-foreground mb-4">سجل التدقيق</h2>
              <div className="space-y-3">
                {[
                  { action: 'تسجيل دخول', time: 'منذ 5 دقائق', icon: '🔑' },
                  { action: 'تقديم طلب APP-12345678', time: 'منذ ساعتين', icon: '📎' },
                  { action: 'تحديث بيانات الملف', time: 'منذ يوم', icon: '✏️' },
                  { action: 'دفع رسوم APP-87654321', time: 'منذ 3 أيام', icon: '💳' },
                ]?.map((log, i) => (
                  <div key={i} className="flex items-center gap-4 p-3 rounded-lg hover:bg-muted transition-colors">
                    <span className="text-xl">{log?.icon}</span>
                    <div className="flex-1">
                      <div className="text-sm font-medium text-foreground">{log?.action}</div>
                    </div>
                    <div className="text-xs text-muted-foreground">{log?.time}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-border shadow-card p-10 text-center">
              <div className="text-4xl mb-3">🛠️</div>
              <h3 className="font-bold text-foreground mb-2">قيد التطوير</h3>
              <p className="text-sm text-muted-foreground">هذه الميزة ستكون متاحة قريبًا</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
